export default function gtmConfig(country: string): string {
  switch (country) {
    case 'fr':
      return 'GTM-KLXJVVC'
    default:
      return ''
  }
}
